import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { CheckCircleIcon } from '@phosphor-icons/react';

export const Route = createFileRoute('/_auth/_side-layout/payments/success')({
  loader: ({ context }) => {
    context.queryClient.invalidateQueries({ queryKey: ['account-details'] });
    context.queryClient.invalidateQueries({ queryKey: ['billing-current'] });
    context.queryClient.invalidateQueries({ queryKey: ['billing-credits'] });
    context.queryClient.invalidateQueries({
      queryKey: ['billing-action-usage'],
    });
  },
  component: PaymentsSuccess,
});

function PaymentsSuccess() {
  return (
    <main className="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <h1 className="flex items-center justify-center gap-2 text-2xl font-bold tracking-tight sm:text-3xl">
          <CheckCircleIcon
            size={32}
            weight="regular"
            className="text-green-500"
          />
          Payment Succeeded
        </h1>
        <p className="text-muted-foreground mt-6 text-base leading-7">
          Your payment has been processed and your account is up to date.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link to="/start-tracking">
            <Button>Start Tracking</Button>
          </Link>
          <Link to="/settings/billing" className="font-semibold">
            View Billing <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>
      </div>
    </main>
  );
}
